import type { NPCConfig } from '@/entities';

const config: NPCConfig[] = [
    //Bunga : lagi didepan rumah kalau didkeetin trigger auto next 'stage;, dia bilang ulang tahn
    //
  {
    x: 2150,
    y: 1450,
    name: 'Bunga',
    color: 0x9932cc, // Dark orchid
    interactionRadius : 75,
    spriteImage: 'assets/sprite/sprite_bunga.png', // Use NPC image
    dialogTree: {
      startDialogId: 'bunga_day1_1',
      triggerOnCollision: true,
      nodes: {
        bunga_day1_1: {
          id: 'bunga_day1_1',
          speaker: 'Bunga',
          text: `Selamat pagi Yan!`,
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_2"
        },
        bunga_day1_2: {
          id: 'bunga_day1_2',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          choices: [
            {
              text: 'Pagi Bunga, sedang apa kamu disini?',
              nextDialogId: 'bunga_day1_3',
            },
            {
              text: 'Selamat pagi Bunga, apa kabar?',
              nextDialogId: 'bunga_day1_3',
            },
          ],
        },
        bunga_day1_3: {
          id: 'bunga_day1_3',
          speaker: 'Bunga',
          text: `Aku membawa hadiah untuk Diana`,
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_4"
        },
        bunga_day1_4: {
          id: 'bunga_day1_4',
          speaker: 'Bunga',
          text: `Aku senang sekali akhirnya Diana sudah 17 tahun`,
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_5"
        },
        bunga_day1_5: {
          id: 'bunga_day1_5',
          speaker: 'Bunga',
          text: `Itu menandakan Diana akhirnya sudah dewasa.`,
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_6"
        },
        bunga_day1_6: {
          id: 'bunga_day1_5',
          speaker: 'Bunga',
          text: `Ayo kita bertemu didalam untuk merayakan bersama Diana, aku sudah membawa kejutan.`,
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_7"
        },
        bunga_day1_7: {
          id: '',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/bunga_h.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          choices: [
            {
              text: '[Jujur] Sebentar, aku lupa, aku harus mencari kado terlebih dahulu',
              nextDialogId: 'bunga_day1_8',
              // storyAction: { type: 'addHostility', value: 1 },
              // storyAction: { type: 'nextDay', value: 1 },
            },
            {
              text: '[Bohong] Ulang tahun Diana? Tentu saja, kado ku sudah ku siapkan! Aku cari udara segar sebentar.',
              nextDialogId: 'bunga_day1_8',
              // storyAction: { type: 'nextDay', value: 1 },
            },
          ],
        },
        bunga_day1_8: {
          id: 'bunga_day1_3',
          speaker: 'Bunga',
          text: `Oke, nanti kembali ke sini ya. Kita masuk bersama. Untuk mengejutkan Diana.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "bunga_day1_9"
        },
        bunga_day1_9: {
          id: '',
          speaker: '',
          text: '',
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          choices: [
            {
              text: 'Oiya, Diana tidak sedang ada dirumah',
              nextDialogId: 'bunga_day1_10',
              // storyAction: { type: 'addHostility', value: 1 },
            },
            {
              text: 'Diana sedang berkeliling dengan Elsa.',
              nextDialogId: 'bunga_day1_10',
              storyActions : [
                { type: 'addCustomValue', value: {key : "bunga_elsa_affinity", value : -1} },
              ]
            },
          ],
        },
        bunga_day1_10: {
          id: 'bunga_day1_3',
          speaker: 'Bunga',
          text: `Oh? Kalau begitu aku harus mencari Diana terlebih dahulu`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "part2_opening0",
        },
        part2_opening0:{
          id: 'part2_opening0',
          speaker: 'Bunga',
          // text: `Oke, nanti kembali ke sini ya. Kita masuk bersama.`,
          text: `Oke, nanti kembali ke sini ya. Kita masuk bersama.`,
          characterImage: '/assets/character/v2/bunga.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          nextDialogId : "part2_opening1",
        },
        part2_opening1: {
          id: 'part2_opening1',
          speaker: 'Yan',
          text: `Sepertinya aku harus mencari kado untuk Diana..`,
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/rumah.png',
          storyAction: { type: 'nextDay', value: 1 },
          isEnd : true
        },
      },
    },
  },
];

export default config;
